import { Badge } from '#/components/ui/badge';
import { ValidatorStatusEnum } from '#/constants/validator-status';
import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import { Translation } from 'intl-lib';
import { CheckCircle, Hourglass, Loader2, LogOut, Zap } from 'lucide-react';
import matchSwitch from 'match-switch';

interface Props {
  item: EthereumStakingValidatorInfo;
}
export function ValidatorStatus({ item }: Props) {
  return matchSwitch(item.status, {
    [ValidatorStatusEnum.PENDING]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs font-normal text-blue-800 bg-blue-50"
      >
        <Hourglass className="size-3.5 mr-1" />
        <Translation path="my_staking.order.order_status.pending" />
      </Badge>
    ),
    [ValidatorStatusEnum.ACTIVE]:
      // exiting
      item.exit === 1 ? (
        <Badge variant="secondary" className="capitalize text-xs font-normal">
          <Loader2 className="size-3.5 mr-1 animate-spin" />
          <Translation path="my_staking.order.order_status.exiting" />
        </Badge>
      ) : (
        <Badge
          variant="secondary"
          className="capitalize text-xs font-normal text-green-800 bg-green-50"
        >
          <CheckCircle className="size-3.5 mr-1" />
          <Translation path="my_staking.order.order_status.active" />
        </Badge>
      ),
    [ValidatorStatusEnum.SLASHED]: (
      <Badge variant="destructive" className="capitalize text-xs font-normal">
        <Zap className="size-3.5 mr-1" />
        <Translation path="my_staking.order.order_status.slashed" />
      </Badge>
    ),
    [ValidatorStatusEnum.EXIT]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs text-slate-500 font-normal"
      >
        <LogOut className="size-3.5 mr-1" />
        <Translation path="my_staking.order.order_status.exited" />
      </Badge>
    ),
  });
}
